import * as ActionTypes from '../action-types'

export function getSites(payload){
    return {
        type: ActionTypes.GET_SITES,
        payload
    }
}


export function getClients(payload){
    return {
        type: ActionTypes.GET_CLIENTS,
        payload
    }
}

export function setPage(payload) {
    return {
        type: ActionTypes.SET_PAGE,
        payload
    }
}

export function setCount(payload) {
    return {
        type: ActionTypes.SET_COUNT,
        payload
    }
}

export function setFilter(filterName, value) {
    return {
        type: ActionTypes.SET_FILTER,
        payload: {filterName, value}
    }
}
export function addPurchases(payload) {
    return {
        type: ActionTypes.ADD_PURCHASES,
        payload: payload
    }
}
export function getNews(payload) {
    return {
        type: ActionTypes.GET_NEWS,
        payload: payload
    }
}